import endpoints from "./endpoints";
import envs from "./envs";

const config = {
 endpoints,
 envs
};

export default config;